import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SmartadminInputModule} from "../../../shared/forms/input/smartadmin-input.module";
import {SmartadminValidationModule} from "../../../shared/forms/validation/smartadmin-validation.module";
import {AccordionModule} from "ng2-bootstrap";
import {UsersActionsComponent} from "./users-actions.component";
import {UsersService} from "../users.service";
import {ProfilesService} from "../../+profiles/profiles.service";
import {GroupsService} from "../../+groups/group.service";
import {ShaService} from "../../../shared/jssha/jssha.service";
import {DrawTreeModule} from "../../+profiles/drawTree/draw-tree.module";
import {JcropModule} from "../../../shared/forms/jcrop/jcrop.module";
import { NgRedux, NgReduxModule } from "ng2-redux";
import {configJcropInitialState} from "../../../shared/forms/jcrop/reducers/jcrop-reducer";
import rootReducer from '../../../shared/+image-cropping/image-editor.reducer'
import {TurnosService} from "../../../+turnosLaborales/turnos.service";
import { NgZorroAntdModule, NzSwitchModule } from 'ng-zorro-antd';
import { GeocercasService } from '../../../+geocercas/geocercas.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DragDropDualListComponent } from '../../../shared/drag-drop-dual-list/drag-drop-dual-list.component';
import { ArrayFilterPipe, ArraySortPipe } from '../../../shared/drag-drop-dual-list/array.pipes';
import { I18nModule } from '../../../shared/i18n/i18n.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { TipoTicketService } from 'app/+admin/+configuraciones/+tickets/+tipos-ticket/tipos.service';


@NgModule({
    imports: [
        I18nModule,
        FormsModule,
        NgReduxModule.forRoot(),
        CommonModule,
        SmartadminInputModule,
        SmartadminValidationModule,
        AccordionModule.forRoot(),
        DrawTreeModule,
        JcropModule,
        NgZorroAntdModule.forRoot(),
        NzSwitchModule,
        ReactiveFormsModule,
        DragDropModule,
        NgSelectModule
    ],
    declarations: [UsersActionsComponent, DragDropDualListComponent, ArraySortPipe, ArrayFilterPipe],
    entryComponents: [UsersActionsComponent],
    providers: [
        UsersService,
        ProfilesService,
        GroupsService,
        GeocercasService,
        ShaService,
        TurnosService,
        TipoTicketService
    ],
    exports: [UsersActionsComponent]
})
export class UsersActionsModule {
    constructor(private ngRedux: NgRedux<any>) {
        this.ngRedux.configureStore(
            rootReducer, {
                apiPanel: configJcropInitialState('apiPanel'),
                defaultPanel: configJcropInitialState('defaultPanel'),
                showSelectionPanel: configJcropInitialState('showSelectionPanel'),
                previewPanel: configJcropInitialState('previewPanel'),
                animationsPanel: configJcropInitialState('animationsPanel'),
                stylingPanel: configJcropInitialState('stylingPanel'),
            }
        );
    }
}
